var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"app-header",attrs:{"app":"","color":_vm.color,"dark":_vm.theme === 'dark',"width":"100%"}},[(_vm.title)?_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-spacer'),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }